export default {"src":"/_next/static/media/share.61f30b94.svg","height":20,"width":18};